import styled, { css } from "styled-components";

export default styled.div.attrs({
  className: "input-with-action",
})`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      margin-top: 20px;
      width: 100%;

      ${media.tablet.up} {
        display: flex;
        justify-content: center;
      }

      .input-with-action {
        &__container {
          background-color: ${colors.primary.white};
          display: grid;
          grid-template-columns: auto 1fr auto;
          grid-template-rows: auto;
          gap: 0;
          align-items: center;
          border: 1px solid ${colors.primary.darkBlue};
          border-radius: 40px;
          padding-left: 15px;
          padding-right: 4px;
          width: 100%;

          ${media.tablet.up} {
            width: 574px;
            height: 58px;
          }

          ${media.mobile.down} {
            grid-template-columns: auto 1fr;
            grid-template-rows: auto auto;
            max-height: none;
            max-width: 310px;
            padding-left: 15px;
            padding-right: 15px;
            margin-bottom: 15px;
            gap: 0;
            align-items: center;
          }
        }

        &__input {
          margin: 0;
          color: ${colors.primary.darkBlue};
          border: none;
          outline: none;
          padding: 0;
          height: 100%;
          width: 100%;
          grid-column: 2;
          grid-row: 1;

          &::placeholder {
            font-size: 12px;
          }

          ${media.mobile.up} {
            &::placeholder {
              font-size: 16px;
            }
          }

          ${media.mobile.down} {
            grid-column: 2;
            grid-row: 1;
            height: 42px;
            padding: 0 10px;
            &::placeholder {
              font-size: 14px;
            }
          }
        }

        &__button {
          &__tablet-up {
            text-transform: uppercase;
            max-width: 170px;
            max-height: 50px;
            grid-column: 3;
            grid-row: 1;
          }

          &__mobile {
            text-transform: uppercase;
            max-height: 42px;
            width: 100%;
            grid-column: 1 / -1;
            grid-row: 2;
            margin-top: 10px;

            ${media.tablet.up} {
              display: none;
            }
            ${media.mobile.down} {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }

      .icon {
        &--left {
          fill: ${colors.primary.darkBlue};
          margin-right: 16px;
          display: flex;

          ${media.mobile.down} {
            margin-right: 0;
            align-self: center;
            margin-bottom: 0;
          }
        }
      }
    `;
  }};
`;
